export default "__VITE_ASSET__DEeWYCJP__"